import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import ActionForm from '@/mixins/ActionForm'
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import Tools from "@/shared/services/tools"
import DataDeCarregamentoViewModel from "@/shared/view-models/DataDeCarregamentoViewModel";
import ProdutoCarregamentoViewModel from "@/shared/view-models/ProdutoCarregamentoViewModel";


const name = 'ProdutoCarregamento'
export default {
  name,
  mixins: [ActionForm],

  components: {
    'g-button' : gButton,
    "g-form" : gForm
  },

  props: {

  },

  async mounted () {
    this.PedidoTemSequencia()
    this.GetDatasInicioEFim()
    this.GetPedidoDefinicaoProducao()
    PedidoController.getComponentesPedido(this.$route.params.id).requisicao
      .then(res => {
        this.componentes = res.data.data;
        // if (this.componentes.descricaoMedidas === null || this.componentes.descricaoMedidas === undefined) {
        //   this.temDescricaoMedidas = false
        // } else {
        //   this.temDescricaoMedidas = true
        // }

        this.componentes.forEach((r)=>{
          r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
            this.ColunaMedidas = r.ColunaMedidas
          })

          this.componentes.forEach((r)=>{
            r.embalagens = []
            r.embalagemFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
            r.embalagemCaixaColetiva == true && r.quantidadeCaixaColetiva != null ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
            r.embalagemPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
            r.embalagemPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadePapelEmbrulho}`) : ''
            r.quantidadeOutros == null || 0  ? '' : r.embalagens.push(r.descricaoEmbalagemOutros == null || '' ? 'Outros -' : r.descricaoEmbalagemOutros + `${r.quantidadeOutros}`) 

      })
      })
    this.$isLoading(true)
    await PedidoController.getInformacoesProdutoCarregamento(this.$route.params.id).requisicao
    .then(res => {
  
      let informacoes = Tools.captalizeKeys(res.data.data);
      Object.assign(this.informacoesProdutoCarregamento, informacoes);
      this.verificaProdutoNovo = res.data.data.verificaProdutoNovo
      this.datasCarregamento = this.converteLista(this.informacoesProdutoCarregamento.DatasCarregamento) || this.criaNovaListaDatasCarregamento();
      this.clienteOrdemCompra = res.data.data.clienteOrdemCompra

      
      // this.limiteQuantidadeTotal = res.data.data.quantidadeTotal
      this.codigoAcessoBloqueado = res.data.data.codigoAcessoBloqueado
      this.$isLoading(false)
      this.informacoesProdutoCarregamento.ValorUnitarioFormatado = this.colocarSimbolo(this.informacoesProdutoCarregamento.ValorUnitarioFormatado,"R$")
      this.QuantidadeTotalPadrao = this.informacoesProdutoCarregamento.QuantidadeTotal

      this.PedidoTemSequencia()

    })
    .catch(() => this.$isLoading(false))

    this.VerificaSeEhUltimaSequencia()
    
    this.getSituacaoPedido()
    this.getTipoPedido()

    this.ImagemEmpresa()
  },

  updated () { },

  data () {
    return {
      keyDataEntregaPedido:0,
      dataMinima: null,
      dataMaxima: null,
      dataDiferenca: 0,
      verificaProdutoNovo: false,
      dataCarregamentoReferencia: {},
      informacoesProdutoCarregamento: new ProdutoCarregamentoViewModel(),
      componentes: [],
      totalAtual: 0,
      quantidadeRestante: 0,
      datasCarregamento: [],
      OrdemCompra: null,
      limiteQuantidadeTotal: null,
      temDescricaoMedidas: false,
      timer: null,
      situacaoPedido: null,
      opcoesDefinicaoDeProducao: [
        {
          texto: 'Produzir junto as parcelas e entregar separado',
          valor: 0,
        },

        {
          texto: 'Produzir junto as parcelas e entregar junto',
          valor: 1,
        },

        {
          texto: 'Produzir junto com o pedido',
          valor: 2,
        },

        {
          texto: 'Complemento do pedido',
          valor: 3,
        },

        {
          texto: 'Única entrega',
          valor: 4,
        },

        {
          texto: 'Produção separada',
          valor: 5,
        },

      ],
      clienteOrdemCompra: null,
      codigoAcessoBloqueado: false,
      imagemEmpresa: '',
      definicaoDeProducaoArray: null,
      tipoPedido: null
    }
  },

  methods: {
    VerificarDataDigitada(valor, index){
      if(this.dataMaxima != null){
        
        let partes = valor.split('/');
        let dia = parseInt(partes[0], 10);
        let mes = parseInt(partes[1], 10);
        let ano = parseInt(partes[2], 10);
        
        const date1 = new Date(ano, mes-1, dia);//valordigitado

        let dia1 = this.dataMaxima.getDate();
        let mes1 = this.dataMaxima.getMonth(); // Mês é baseado em zero, então adicionamos 1
        let ano1 = this.dataMaxima.getFullYear();

        const date2 = new Date(ano1,mes1,dia1); //datamaxima

        if(date1 > date2 ){
          // Adiciona um zero à esquerda se o dia ou o mês for menor que 10 
          dia1 = dia1 < 10 ? '0' + dia1 : dia1;
          mes1 = mes1 < 10 ? '0' + mes1 : mes1;
          // Formata a data como "DIA/MES/ANO"
          // var dataFormatada = dia1 + '/' + mes1 + '/' + ano1;

          this.datasCarregamento[index].DataCarregamento = null
          this.keyDataEntregaPedido++

          this.$toast.add({ severity: 'error', summary: 'DATA DE CARREGAMENTO', detail: `DATA SUPERIOR A DATA LIMITE!`, life: 3000 });

        }
     
       }

    },
    colocarSimbolo(valor,simbolo){
      if(valor && simbolo){
        return simbolo + " "+valor
      }
      return ""
    },
    GetDatasInicioEFim(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDatasInicioEFim/${this.$route.params.id}`,
      })
        .then((response) => {
          if(response.data.data != null)
          {
            var dataInicio = response.data.data.dataInicioFormatada
            var mesInicio = response.data.data.mesInicioFormatada
            var anoInicio = response.data.data.anoInicioFormatada
  
            var dataFim = response.data.data.dataFimFormatada
            var mesFim = response.data.data.mesFimFormatada
            var anoFim = response.data.data.anoFimFormatada
  
            this.dataMinima = new Date(anoInicio,mesInicio-1,dataInicio)
  
            this.dataMaxima = new Date(anoFim,mesFim-1,dataFim)
          }
          else
          {
            this.dataMinima = null
  
            this.dataMaxima = null
          }

          
        })
        .catch();
    },
    ImagemEmpresa(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetNomeEmpresaByPedidoId/${this.$route.params.id}`,
      })
        .then((response) => {

          this.NomeEmpresa=response.data.message

          const nomeEmpresa = () => {
            if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
            if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
            return 'JAUENSE'
          }
  
          const urlBase = window.location.host
          this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
        })
        .catch();
    },
    deletarDataCarregamento(index){
      if(this.quantidadeDatasCarregamento > 1){
        this.datasCarregamento.splice(index, 1);
        let totalDeDatas = this.datasCarregamento.length
        let quantidadeTotal = this.informacoesProdutoCarregamento.QuantidadeTotal;
        let sobraQuantidade = quantidadeTotal % totalDeDatas;
        let quantidadeParaCadaData = (quantidadeTotal - sobraQuantidade) / totalDeDatas;

        this.datasCarregamento.forEach(e => e.Quantidade = quantidadeParaCadaData);
      }
    },

    criaNovaListaDatasCarregamento(){
      let primeiraDataCarregamento = new DataDeCarregamentoViewModel()
      // let agora = new Intl.DateTimeFormat('pt-BR').format(new Date())

      // primeiraDataCarregamento.Quantidade = this.informacoesProdutoCarregamento.QuantidadeTotal
      // primeiraDataCarregamento.DataCarregamento = agora

      this.datasCarregamento.push(primeiraDataCarregamento)
      return this.datasCarregamento
    },

    converteLista(lista){
      if(!lista){
        return null;
      }
      let novaLista = [];

      lista.forEach(e => {
        novaLista.push(new DataDeCarregamentoViewModel(e.dataCarregamentoFormatado, e.quantidade, e.ordemDeCompra))
      })
      return novaLista;
    },

    adicionarDataCarregamento(){
      let novaDataCarregamento = new DataDeCarregamentoViewModel()

      // let agora = new Date()
      // let proximaDataCarregamento = agora.setMonth(agora.getMonth() + this.datasCarregamento.length);
      // novaDataCarregamento.DataCarregamento = new Intl.DateTimeFormat('pt-BR').format(proximaDataCarregamento);

      this.datasCarregamento.push(novaDataCarregamento);

      // let totalDeDatas = this.datasCarregamento.length
      // let quantidadeTotal = this.informacoesProdutoCarregamento.QuantidadeTotal;
      // // let sobraQuantidade = quantidadeTotal % totalDeDatas;
      // let quantidadeParaCadaData = (quantidadeTotal - sobraQuantidade) / totalDeDatas;

      // this.datasCarregamento.forEach(e => e.Quantidade = quantidadeParaCadaData);
      // this.datasCarregamento[0].Quantidade += sobraQuantidade;
    },


    PedidoTemSequencia(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Pedido/PedidoTemSequencia/${this.$route.params.id}`,
      })
        .then((response) => {
          this.temSequencia=response.data
          // if(this.temSequencia == false){
          //   this.limiteQuantidadeTotal = getInformacoesProdutoCarregamento().QuantidadeTotal

          // }



        })
        .catch();
    },
    calculaQuantidadeRestante(){
      let quantidadeTotal = this.informacoesProdutoCarregamento.QuantidadeTotal ? this.informacoesProdutoCarregamento.QuantidadeTotal : 0;

      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/CalculaQuantidadeRestante/${quantidadeTotal}/${this.$route.params.id}`,
      })
      .then((response) =>{
        this.quantidadeRestante = response.data.data;
        if( this.quantidadeRestante < 0){

          this.informacoesProdutoCarregamento.QuantidadeTotal = 0;
        }
        else{
          this.informacoesProdutoCarregamento.QuantidadeTotal = this.quantidadeRestante;
        }



      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },
    VerificaSeEhUltimaSequencia(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/VerificaSeEhUltimaSequencia/${this.$route.params.id}`,
      })
      .then((response) =>{
        let res = response.data.data
        if(res == true) {
          this.calculaQuantidadeRestante();
        }
         return res;
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    calculaPrecoSemIPI(e) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$isLoading(true)
        let quantidade = e.value

        // if(quantidade < this.QuantidadeTotalPadrao && this.temSequencia == false){
        //   quantidade = this.QuantidadeTotalPadrao
        //   this.informacoesProdutoCarregamento.QuantidadeTotal = quantidade
        //   this.$toast.add({ severity: 'info', summary: 'Quantidade Total', detail: `A Quantidade Total não pode ser menor que o quantidade original, de ${quantidade}! O valor original foi restaurado.`, life: 3000 });
        //   this.$isLoading(false)
        //   return
        // }

        PedidoController.getValorSemIpi(quantidade, this.$route.params.id).requisicao
        .then((res) => {
          this.informacoesProdutoCarregamento.ValorTotalSemIPIFormatado = res.data.data
          this.$isLoading(false)
        })

      }, 2000)
    },

    Continuar () {
      this.$refs.botaoContinuar.isBusy()
      
        this.informacoesProdutoCarregamento.DatasCarregamento = this.datasCarregamento;
        let quantidadeTotal = this.informacoesProdutoCarregamento.QuantidadeTotal;
        let variavelInvalida = false;

        if(quantidadeTotal < this.QuantidadeTotalPadrao && this.temSequencia == false){
          quantidadeTotal = this.QuantidadeTotalPadrao
          
          this.informacoesProdutoCarregamento.QuantidadeTotal = quantidadeTotal
          this.$toast.add({ severity: 'info', summary: 'Quantidade Total', detail: `A Quantidade Total não pode ser menor que o quantidade original, de ${quantidadeTotal}! O valor original foi restaurado.`, life: 3000 });
          //this.$isLoading(false)
          this.$refs.botaoContinuar.isBusy()

          return
        }

        // this.calculaQuantidadeRestante();


        if(quantidadeTotal < this.quantidadeRestante && !this.VerificaSeEhUltimaSequencia()) {
            this.$toast.add({ severity: 'info', summary: 'Quantidade Total', detail: `A Quantidade do pedido não atingiu o minimo de ${this.quantidadeRestante}!`, life: 6000 });
            this.$refs.botaoContinuar.isBusy()
            return
        }
      
      //Amanha fazer requisição aqui
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Pedido/GetDataDiferenca/${this.$route.params.id}`
        }).then((response) => {
          this.dataDiferenca = response.data;

        // Validação campos Data de Carregamento:
        for (let i = 0; i < this.datasCarregamento.length; i++) {

          const element = this.datasCarregamento[i];
          if(this.dataDiferenca != "") {
            if( i == 0) {
              var dataString0 = element.DataCarregamento;
              var partesDaDataNova = dataString0.split('/'); 
              var dia = parseInt(partesDaDataNova[0]);
              var novaData = partesDaDataNova[1] + '-' + ( dia + this.dataDiferenca) + '-' +  partesDaDataNova[2]
              var novaDataFormatada = new Date(novaData);
            }
            if( i > 0) {
              var dataString = element.DataCarregamento;
              var partesDaData = dataString.split('/'); 
              var dia2 = parseInt(partesDaData[0])
              var dataFormatada = partesDaData[1]  + '-' + dia2 + '-' + partesDaData[2]; 
              var dataDigitada = new Date(dataFormatada);

              if (dataDigitada < novaDataFormatada) {
                this.$toast.add({ severity: 'info', summary: 'Data de Carregamento', detail: `A distancia entre as datas de carregamento precisa ser de ${this.dataDiferenca} dia(s) `, life: 3000 });
                this.$refs.botaoContinuar.isBusy()
                return;              
              }
            }
          }
          if(element.DataCarregamento === undefined || element.DataCarregamento === null || element.DataCarregamento === ''  ){
            this.$toast.add({ severity: 'info', summary: 'Data de Carregamento', detail: `Data de Carregamento é obrigatória`, life: 3000 });
            this.$refs.botaoContinuar.isBusy()
            return;
          }
        }})

      // Validação campo Quantidade:

      if(quantidadeTotal < this.quantidadeTotalDatasCarregamento()){
        this.$toast.add({ severity: 'info', summary: 'Quantidade total', detail: `A quantidade total deve ser de  ${this.quantidadeTotalDatasCarregamento()}`, life: 3000 });
        this.$refs.botaoContinuar.isBusy()
        return;
      }

      if(quantidadeTotal != this.quantidadeTotalDatasCarregamento()){
        this.$toast.add({ severity: 'info', summary: 'Quantidade total', detail: `As quantidades de carregamento precisam somar ${quantidadeTotal}`, life: 3000 });
        this.$refs.botaoContinuar.isBusy()
        return;
      }

        // Validação campos Ordem de Compra:

      if(this.clienteOrdemCompra){
        for (let i = 0; i < this.datasCarregamento.length; i++) {
          const element = this.datasCarregamento[i];

          variavelInvalida = Tools.validaVariavelPreenchida(element.OrdemDeCompra);
          if(variavelInvalida){
            this.$toast.add({ severity: 'info', summary: 'Ordem de Compra', detail: `Ordem de Compra é obrigatório`, life: 3000 });
            this.$refs.botaoContinuar.isBusy()
            return;
          }
        }
      }

      // Validações campos Definição de Produção
      // Amostra (tipoPedido === 1): dropdown e textuais desabilitados no template — sem validação.
      // Pedido / PedidoProva: dropdown sempre obrigatório + matriz condicional para os 2 textuais.
      if (this.tipoPedido !== 1) {
        if (this.verificaCampoVazio(this.informacoesProdutoCarregamento.DefinicaoPedido)) {
          this.$toast.add({ severity: 'info', summary: 'Definição de Produção', detail: `Definição de Produção é obrigatório`, life: 3000 });
          this.$refs.botaoContinuar.isBusy()
          return;
        }

        const def = this.informacoesProdutoCarregamento.DefinicaoPedido;
        const exigeCodigoPedido = (def === 2 || def === 3);
        const exigeObservacao = (def === 0 || def === 1 || def === 2 || def === 3);

        if (exigeCodigoPedido && this.verificaCampoVazio(this.informacoesProdutoCarregamento.CodigoPedidoDefinicao)) {
          this.$toast.add({ severity: 'info', summary: 'Definição de Produção', detail: `Definição de Produção - Pedido é obrigatório para a opção selecionada`, life: 3000 });
          this.$refs.botaoContinuar.isBusy()
          return;
        }

        if (exigeObservacao && this.verificaCampoVazio(this.informacoesProdutoCarregamento.ObservacaoDefinicao)) {
          this.$toast.add({ severity: 'info', summary: 'Definição de Produção', detail: `Definição de Produção - Observação é obrigatório para a opção selecionada`, life: 3000 });
          this.$refs.botaoContinuar.isBusy()
          return;
        }
      }
      

      let arrayDataCarregamento = this.informacoesProdutoCarregamento.DatasCarregamento.map((element) => {
        var data = (element.DataCarregamento)
        return data
      })

      // const VerificaOrdemDataCarregamento = arr => arr.every((v,i,a) => !i || a[i-1] <= v) ;

      function VerificaOrdemDataCarregamento(arrayDeDatas) {
        for (let i = 0; i < arrayDeDatas.length - 1; i++) {
          const dataAtual = parseData(arrayDeDatas[i]);
          const proximaData = parseData(arrayDeDatas[i + 1]);
      
          if (dataAtual > proximaData) {
            return false;
          }
        }
        return true;
      }
      
      function parseData(dataString) {
        const partes = dataString.split('/');
        const dia = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1; // Mês é baseado em zero (janeiro = 0)
        const ano = parseInt(partes[2], 10);
      
        return new Date(ano, mes, dia);
      }

      if (VerificaOrdemDataCarregamento(arrayDataCarregamento) == false){
        this.$toast.add({ severity: 'info', summary: 'Datas de Carregamento', detail: `As Datas do Carregamento devem estar em sequência!`, life: 3000 });
        this.$refs.botaoContinuar.isBusy()
        return;
      } 
      // Método para salvar
      this.$isLoading(true)
      PedidoController.postProdutoCarregamento(this.$route.params.id, this.informacoesProdutoCarregamento).requisicao
        .then(res => {
          if(res.data.code === 200){
            this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/carac-produto-pedido`)
          }
          else{
            if(res.data.message.includes("P00")){
              this.$toast.add({ severity: 'error', summary: 'Pedido', detail: res.data.message, life: 3000 });
            }
          }
            this.$isLoading(false)
        }).finally(this.$refs.botaoContinuar.isBusy());
    },

    voltar(){
      this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/info-frete-pedido`)
    },

    quantidadeTotalDatasCarregamento(){
      return this.datasCarregamento.reduce((total, dataQuantidade) => {
        let a = total + parseInt(dataQuantidade.Quantidade)
        return a;
      }, 0)
    },
    mudarValorIPI(){
      // let soma = this.informacoesProdutoCarregamento.QuantidadeTotal + this.informacoesProdutoCarregamento.ValorTotalSemIPIFormatado
      // let a = Number(this.informacoesProdutoCarregamento.ValorTotalSemIPIFormatado);
    },

    limpaCamposDefinicaoProducao(){
      this.informacoesProdutoCarregamento.ObservacaoDefinicao = null
      this.informacoesProdutoCarregamento.CodigoPedidoDefinicao = null
    },

    verificaCampoVazio(campo){
      if (campo === undefined || campo === null || campo === "" || campo === '')
        return true
      else
        return false
    },

    verificaCamposDefinicaoProducao(pedido, observacao){
      if ((pedido === undefined || observacao === undefined) ||
          (pedido === null || observacao === null) ||
          (pedido === '' || observacao === '') ||
          (pedido === "" || observacao === ""))
      return true
    else
      return false
    },

    getSituacaoPedido() {
      PedidoController.GetSituacaoPedido(this.$route.params.id).requisicao
        .then((res => {
          this.situacaoPedido = res.data.data
          if (this.situacaoPedido === 1)
            this.informacoesProdutoCarregamento.DefinicaoPedido = null
        }))
      },

    getTipoPedido(){
      PedidoController.GetTipoPedido(this.$route.params.id).requisicao
        .then((res => {
          this.tipoPedido = res.data.data
        }))
    },

    GetPedidoDefinicaoProducao() {
      PedidoController.GetPedidoDefinicaoProducao().requisicao
        .then((res => {
          this.definicaoDeProducaoArray = res.data
        }))
        .catch()
    }
  },


  computed: {
    quantidadeReferencia(){
      return this.dataCarregamentoReferencia.Quantidade
    },

    quantidadeDatasCarregamento(){
      return this.datasCarregamento.length
    },
   

    exibirComplementoPedido(){
      return [0, 2, 3].includes(this.informacoesProdutoCarregamento.DefinicaoPedido)
    }
  },

  watch:{
    


    quantidadeReferencia(valor){
      let valorInteiro = parseInt(valor);
      let somaTotalQuantidades = this.quantidadeTotalDatasCarregamento();
      let quantidadeTotal = this.informacoesProdutoCarregamento.QuantidadeTotal;

      if(valorInteiro < 1){
        this.dataCarregamentoReferencia.Quantidade = 1
        return;
      }
      if((somaTotalQuantidades) > quantidadeTotal){
        let diferenca = somaTotalQuantidades - quantidadeTotal;
        this.dataCarregamentoReferencia.Quantidade = valorInteiro - diferenca;
      }
    }
  }

};